<template>
  <qx-card title="列表">
    <CarDetailDialog ref="carDetailDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="300000" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span v-if="scope.row.orderType === 1">固定：</span>
                  <span v-else-if="scope.row.orderType === 2">临时：</span>
                  <span v-else>三方：</span>
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 运输线路 -->
                <section
                  v-else-if="scope.column.property === 'sourceRegionName'"
                >
                  <span
                    :class="{
                      primary: scope.row.sourceId !== -1,
                      cur: scope.row.sourceId !== -1,
                    }"
                    @click="toLineDetail(scope.row)"
                  >
                    {{
                      `${scope.row.sourceRegionName.replace(
                        '市',
                        ''
                      )}-${scope.row.desRegionName.replace('市', '')}`
                    }}
                  </span>
                </section>
                <!-- 运输线路 end -->
                <!-- 车牌号码 -->
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <el-popover placement="top" width="120" trigger="hover">
                    <div style="text-align: left">
                      <p>司机：{{ scope.row.carDriverMan }}</p>
                      <p>手机：{{ scope.row.carDriverPhone }}</p>
                      <p>车型：{{ scope.row.vehicleClassName }}</p>
                    </div>
                    <span class="primary cur" slot="reference">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </el-popover>
                </section>
                <!-- 车牌号码 end -->
                <!-- 货物信息 -->
                <section v-else-if="scope.column.property === 'goodsName'">
                  {{ scope.row.goodsName }}
                  \
                  {{ scope.row.weight ? scope.row.weight + '吨' : '' }}
                  \
                  {{ scope.row.square ? scope.row.square + '立方' : '' }}
                </section>
                <!-- 货物信息 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="3300195">
                  <span
                    class="primary cur"
                    @click="toDetail(scope.row, 'approve')"
                    v-if="scope.row.isJurisdiction"
                    >审核</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.orderId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import CarDetailDialog from 'components/carDetailDialog';
import LogRightDialog from 'components/logRightDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  orderApproveList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    CarDetailDialog,
    LogRightDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号码',
            w: 140,
          },
          {
            prop: 'customName',
            label: '客户名称',
          },
          {
            prop: 'sourceRegionName',
            label: '运输线路',
            w: 160,
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'goodsName',
            label: '货物信息',
            w: 160,
          },
          {
            prop: 'dependTime',
            label: '发车时间',
          },
          {
            prop: 'auditSourceName',
            label: '审核来源',
          },
          {
            prop: 'orderStateName',
            label: '订单状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderApproveList,
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showCarDetail (item) {
      this.$refs.carDetailDialog.show(item);
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核订单' : '订单详情',
        url: '/manage/operate/order/approve/approvePage?' +
          'orderState=' + item.orderState +
          '&orderUpdateState=' + item.orderUpdateState +
          '&joinAuditType=' + item.joinAuditType +
          '&id=' + item.orderId +
          '&type=' + type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
